import classnames from 'classnames'
import styles from './styles.module.scss'

const ValidationError = ({ children, className }) =>
    children ? (
        <p role="alert" className={classnames(styles.validationError, className)}>
            {children}
        </p>
    ) : null

export default ValidationError
